module.exports = __webpack_public_path__ + "static/media/Tuesday.07124ece.webp";